import { Box, keyframes } from "@mui/material";
import type { ReactNode } from "react";
import { StatusDot } from "@/pages/workOrders/components/StatusCell";
import { PRINT_STATUS_COLOR, KIND_COLOR, statusInfo } from "../statusInfo";

const pulse = keyframes`50% { opacity: 0.2; }`;

// the dot fades and comes back: the status is live
export const liveDotSx = {
	"& > span:first-of-type": { animation: `${pulse} 2s ease-in-out infinite` },
	"@media (prefers-reduced-motion: reduce)": {
		"& > span:first-of-type": { animation: "none" },
	},
} as const;

const Label = ({
	color,
	live = false,
	children,
}: {
	color: string;
	live?: boolean;
	children: ReactNode;
}) => (
	<Box
		component="span"
		sx={{
			display: "inline-flex",
			alignItems: "center",
			color,
			fontSize: "0.8125rem",
			fontWeight: 500,
			whiteSpace: "nowrap",
			...(live && liveDotSx),
		}}
	>
		<StatusDot color={color} />
		{children}
	</Box>
);

export const PrinterStatusLabel = ({ status }: { status: string | null }) => {
	const { label, kind } = statusInfo(status);
	return (
		<Label color={KIND_COLOR[kind]} live={kind === "ok"}>
			{label}
		</Label>
	);
};

export const PrintStatusLabel = ({ status }: { status: string }) => (
	<Label color={PRINT_STATUS_COLOR[status] ?? KIND_COLOR.off}>{status}</Label>
);
